document.addEventListener('DOMContentLoaded', function () {
    const blockBoxBenefits = document.querySelectorAll('.block-box-benefits');

    if (blockBoxBenefits.length === 0) return;
    if (typeof gsap === 'undefined') return;

    if (typeof ScrollTrigger !== 'undefined') {
        gsap.registerPlugin(ScrollTrigger);
    }

    // Loop through each block-box-benefits section
    blockBoxBenefits.forEach(function (blockBoxBenefits) {
        const blockBoxBenefitsHeading = blockBoxBenefits.querySelector('.block-box-benefits__heading');
        const blockBoxBenefitsContent = blockBoxBenefits.querySelector('.block-box-benefits__content');
        const blockBoxBenefitsBenefits = blockBoxBenefits.querySelectorAll('.block-box-benefits__benefit');

        // Check if the heading element exists
        if (blockBoxBenefitsHeading) {
            gsap.fromTo(blockBoxBenefitsHeading, {
                autoAlpha: 0,
                x: -60,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockBoxBenefits,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if the content element exists
        if (blockBoxBenefitsContent) {
            gsap.fromTo(blockBoxBenefitsContent, {
                autoAlpha: 0,
                x: -60,
            }, {
                autoAlpha: 1,
                x: 0,
                duration: 0.6,
                ease: 'power3.out',
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockBoxBenefits,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }

        // Check if benefit elements exist
        if (blockBoxBenefitsBenefits.length) {
            gsap.fromTo(blockBoxBenefitsBenefits, {
                autoAlpha: 0,
                y: 60,
            }, {
                autoAlpha: 1,
                y: 0,
                duration: 0.6,
                ease: 'power3.out',
                stagger: 0.1,
                scrollTrigger: typeof ScrollTrigger !== 'undefined' ? {
                    trigger: blockBoxBenefits,
                    start: 'top 80%',
                    once: true,
                } : null,
            });
        }
    });
});
